import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navigation from './components/layout/Navigation';
import Footer from './components/layout/Footer';
import Home from './components/pages/Home';
import Details from './components/pages/Details';
import Photos from './components/pages/Photos';
import ThingsToDo from './components/pages/ThingsToDo';
import RSVP from './components/pages/RSVP';
import './index.css';

function App() {
  return (
    <Router>
      <div className="min-h-screen flex flex-col bg-white">
        <Navigation />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/details" element={<Details />} />
            <Route path="/photos" element={<Photos />} />
            <Route path="/things-to-do" element={<ThingsToDo />} />
            <Route path="/rsvp" element={<RSVP />} />
          </Routes>
        </main>
        <Footer />
    </div>
    </Router>
  );
}

export default App;
